import React, { memo } from 'react';
import { MapBalloon } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorBrandYamahaRed } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel4 } from '@yme/tokens/typography';
export const DistanceLabel = memo(({ isRightToLeft, distance, label }) => {
    return (React.createElement(FlexWrapper, { gap: "8px", alignItems: "center", flexDirection: isRightToLeft ? 'row-reverse' : 'row', as: "span" }, Boolean(distance) && (React.createElement(React.Fragment, null,
        React.createElement(RegularTextLevel4, { weight: 500, as: "span" }, label),
        React.createElement(SVGIcon, { type: MapBalloon, pathFill: colorBrandYamahaRed })))));
});
DistanceLabel.displayName = 'DistanceLabel';
